import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {
  
  // メインビジュアル
  const mvSplideId = document.getElementById('mvSplide');
  if ( mvSplideId ) {
    const mvSplide = new Splide('#mvSplide', {
      type : 'fade',
      rewind: true,
      autoplay: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false,
      pagination: false,
      lazyLoad: 'sequential',
      interval: 7000,
      speed: 4000,
    });
    mvSplide.mount();
  }

  // 投稿リスト
  document.querySelectorAll('.splide-slide').forEach((el) => {
    const splideInstance = new Splide( el, {
      type : 'slide',
      fixedWidth: '64%',
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: true,
      pagination: true,
      lazyLoad: 'sequential',
      speed: 500,
      mediaQuery: 'min',
      gap: '10px',
      focus: 0,
      omitEnd: true,
      breakpoints: {
        600: {
          fixedWidth: '40%',
          gap: '20px',
        },
        1000: {
          fixedWidth: '31.5%',
          gap: '2.75%',
        },
      }
    });

    splideInstance.on('overflow', function (isOverflow) {
      splideInstance.options = {
        arrows    : isOverflow,
        pagination: isOverflow,
        drag      : isOverflow,
      };
    });
    
    splideInstance.mount();
  });

  // アイテムスライダー
  const mainId = document.getElementById('main-carousel');
  const thumbId = document.getElementById('thumb-carousel');

  if ( mainId && thumbId ) {
    const main = new Splide('#main-carousel', {
      type : 'fade',
      arrows: true,
      pagination: false,
      speed: 1000,
    });

    const thumb = new Splide('#thumb-carousel', {
      type : 'slide',
      arrows: false,
      pagination: false,
      fixedWidth: 60,
      fixedHeight: 60,
      gap: 10,
      cover: true,
      isNavigation: true,
      speed: 500,
      mediaQuery: 'min',
      breakpoints: {
        1000: {
          fixedWidth: 80,
          fixedHeight: 80,
          gap: 15,
          height: '100%',
          direction: 'ttb',
        },
      }
    });
    main.sync( thumb );
    main.mount();
    thumb.mount();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  // コーディネートリスト
  let splideInstances = [];

  const initializeCoordinationSplide = () => {
    // 既存のSplideインスタンスをすべて破棄
    splideInstances.forEach(instance => instance.destroy(true));
    splideInstances = [];

    document.querySelectorAll('.splide-slide-coordination').forEach((el) => {
      const splideInstance = new Splide(el, {
        type: 'slide',
        fixedWidth: '40%',
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: true,
        pagination: true,
        lazyLoad: 'sequential',
        speed: 500,
        mediaQuery: 'min',
        gap: 'clamp(0.625rem, 0.385rem + 0.96vw, 1.25rem)',
        focus: 0,
        omitEnd: true,
        breakpoints: {
          600: {
            fixedWidth: '30%',
          },
          1000: {
            fixedWidth: 'calc(25% - 7.5px)',
          },
        }
      });

      splideInstance.on('overflow', function (isOverflow) {
        splideInstance.options = {
          arrows: isOverflow,
          pagination: isOverflow,
          drag: isOverflow,
        };
      });

      splideInstance.mount();
      splideInstances.push(splideInstance); // インスタンスを配列に追加
    });
  }

  initializeCoordinationSplide();

  document.querySelectorAll('.arkb-tabList__button').forEach((button) => {
    button.addEventListener('click', () => {
      setTimeout(() => {
        initializeCoordinationSplide();
      }, 100); // 100ms待って再初期化
    });
  });
});
